<template>
  <div>
    <TopLogo />
    <div class="benner">
      <div class="benner-box">
        <div class="b-logo">
          <img v-if="info.topPicture" :src="info.topPicture" />
          <img v-else src='../assets/no-picture.png'/>
        </div>
        <div class="b-title">
          <h1>{{info.merchantName || '加载中...'}}</h1>
          <p>可用 <span class="b-color">{{info.points || 0}} 积分</span> <router-link class="b-href" :to="`/my/jifen/${info.merchantCode || ''}`">积分明细 ></router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TopLogo from "./top-logo";
export default {
  name: "Top",
  props: {
    title: String
  },
  computed: {
    ...mapGetters({ info: "shopInfo" })
  },
  components: {
    TopLogo
  },
  created() {
    // let oUrl = this.$route.path
    // let id
    // if( oUrl.indexOf('product') > 0 ){
    //   id = oUrl.substring(oUrl.indexOf('/') + 9, oUrl.lastIndexOf('/'))
    // } else {
    //   id = this.$route.params.id
    // }
    // this.$store.dispatch("SHOPINFO", id);
  }
};
</script>
<style>
.benner {
  width: 100%;
  height: 130px;
  margin: 0 auto;
  text-align: center;
  padding: 0;
  position: relative;
  background: url("../assets/top.png") 50% 0 repeat-y;
}

.benner-box {
  width: 1200px;
  height: 130px;
  margin: auto;
  text-align: left;
  overflow: hidden;
  color: #fff;
}
.b-logo {
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 6px;
  float: left;
  margin-top: 24px;
  line-height: 80px;
}
.b-logo img {
  max-width: 80px;
  max-height: 80px;
  border-radius: 6px;
  vertical-align: middle;
}
.b-title {
  margin: 32px 0 20px 20px;
  float: left;
  line-height: 36px;
}
.b-title h1 {
  font-weight: inherit;
  font-size: 28px;
}
.b-title p {
  font-size: 14px;
}
.b-title .b-color {
  color: #ffcc00;
}
.b-href {
  margin-left: 10px;
  color: #fff;
}
.b-href:hover {
  text-decoration: underline;
}
</style>
